// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"aa9d6a6e","25":"15d04db0","238":"36b8c3a0","412":"104fc52a","496":"859c67f7","526":"2a7d370c","678":"e4526a6a","856":"fde64a52","984":"b8937efe"}[chunkId] + ".chunk.js";
};